export default {
  getLoaded: state => state.loaded,
  getMenu: state => state.menu,
  getDetail: state => state.detail,
  getFormStatus: state => state.formStatus,
  getNextType: state => state.nextType,
};
